import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'pf-checkbox',
  imports: [ReactiveFormsModule],
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './checkbox.component.scss',
})
export class CheckboxComponent {
  @Input() value: boolean = false;
  @Input() label = '';
  @Input() inputFormControl: FormControl = new FormControl();

  @Output() onChange = new EventEmitter();
  public uncheck() {
    this.inputFormControl.setValue(false);
  }
  public ngOnInit() {
    this.inputFormControl.setValue(this.value)
    this.inputFormControl.valueChanges.subscribe(change => {
      this.onChange.emit(this.inputFormControl);
    });
  }
}
